// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f2f104b6","845":"12b53167"}[chunkId] + ".chunk.js";
};